import React, { useMemo } from "react";
import { Chip, Tooltip } from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';

const TagList = ({ tags, values, handleDelete }) => {

  const groupTags = useMemo(() => {
    if (!values?.length || !tags?.length) return [];
    return tags.filter((item) => values.includes(item.key));
  }, [tags, values])

  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
      {
        groupTags.map((item) => {
          return (
            <Tooltip
              key={item.key}
              title={item.value}
              arrow
            >
              <Chip
                label={item.value}
                onDelete={handleDelete ? () => handleDelete(item.key) : null}
                deleteIcon={<CancelIcon style={{ fill: "var(--mainText)" }} />}
                style={{
                  background: 'var(--tertiaryBackgroundColor)',
                  border: '1px solid var(--borderColor)',
                }}
                className="whiteText"
              />
            </Tooltip>
          )
        })
      }
    </div>
  )
}

export default TagList;